import { render, staticRenderFns } from "./BoxPerformanceComparisonRadarRegion.vue?vue&type=template&id=0f6c9640&scoped=true&"
import script from "./BoxPerformanceComparisonRadarRegion.vue?vue&type=script&lang=js&"
export * from "./BoxPerformanceComparisonRadarRegion.vue?vue&type=script&lang=js&"
import style0 from "./BoxPerformanceComparisonRadarRegion.vue?vue&type=style&index=0&id=0f6c9640&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6c9640",
  null
  
)

export default component.exports
import {QCard,QTable} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QTable})
